var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-height":"500px"}}),_vm._l((0),function(i){return _c('DownloadCell',{key:i.index})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }